import React from 'react';
import { Avatar } from '@mui/material';

// Random color
const getRandomColor = (): string => {
  const colors = ['#EF6C00', '#0097A7', '#7B1FA2', '#C2185B', '#3949AB', '#00897B', '#D32F2F'];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Calculate the contrast depending on black and white
const getContrastColor = (hexColor: string): 'black' | 'white' => {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? 'black' : 'white';
};

interface Props {
  name: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const AvatarInitials: React.FC<Props> = ({ name, onClick }) => {
  const initials = name
    .split(' ')
    .map(n => n[0]?.toUpperCase())
    .slice(0, 2)
    .join('');

  const backgroundColor = React.useMemo(() => getRandomColor(), []);
  const textColor = getContrastColor(backgroundColor);

  return (
    <Avatar
      onClick={onClick}
      sx={{
        bgcolor: backgroundColor,
        color: textColor,
        width: 48,
        height: 48,
        fontWeight: 'bold',
        cursor: 'pointer'
      }}
    >
      {initials}
    </Avatar>
  );
};

export default AvatarInitials;